import * as React from "react";

import { Error404Page } from "tabler-react";

type Props = {};

const Error404 = () => <Error404Page />;

export default Error404;
